export { GlobalProvider, GlobalContext } from "./GlobalContext";
